import { Component, OnInit } from "@angular/core";
import { PortalAppImportDataRequest } from "../shared/portal-app-import-data-request";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "caass-portal-app-batch-import",
	templateUrl: "./portal-app-batch-import.component.html",
	styleUrls: ["./portal-app-batch-import.component.css"],
})
export class PortalAppBatchImportComponent implements OnInit {
	constructor(private ref: DynamicDialogRef) {}
	ngOnInit(): void {}

	///////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////

	FileName: string = "";
	ImportFile: any; //Data
	FileData: any = null;

	AppTypeID: number = 1;
	lstAppType: any = [
		{
			ID: 1,
			Desc: "Parent Portal",
		},
		{
			ID: 2,
			Desc: "Student Portal",
		},
		{
			ID: 3,
			Desc: "Staff Portal",
		},
	];

	FormatOptionID: number = 1;
	lstFormatOption: any = [
		{
			ID: 1,
			Desc: "Tab Delimited",
		},
		{
			ID: 2,
			Desc: "Comma Delimited",
		},
	];

	PreviewLines: number = 3;
	lstRequiredColumns: any = [
		{
			ID: 0,
			Desc: "- Ignore Column -",
		},
		{
			ID: 1,
			Desc: "ID",
		},
		{
			ID: 2,
			Desc: "Email",
		},
	];

	SkipFirstLineID: number = 0;
	lstSkipFirstLineID: any = [
		{
			ID: 0,
			Desc: "Don't Skip (No Headers)",
		},
		{
			ID: 1,
			Desc: "Skip Headers",
		},
	];

	lstTable: any = [];
	lstCols: any = [];
	OptArray: number[] = [];

	ReadyToImport: boolean = false;
	Processing: boolean = false;
	LoadingFile: boolean = false;

	ErrorMessage: string = "";

	pagerows: any = 10;
	pagefirst: any = 0;

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////

	onSelectFile() {
		this.ErrorMessage = "";

		document.getElementById("ImportInput").click();
	}

	onFileToImportChange(val) {
		this.ImportFile = val.target.files[0];
		this.FileName = this.ImportFile.name;

		// console.log(this.ImportFile);

		if (this.ImportFile.type != "text/plain" && this.ImportFile.type != "text/csv") {
			this.ErrorMessage = "Invalid File Type. It might be easier to use the Export option and then import the file that was exported.";
			return;
		}

		var fr = new FileReader();
		fr.readAsText(this.ImportFile);
		// fr.readAsDataURL(this.ImportFile);

		fr.onload = () => {
			this.FinishLoadFile(fr.result);
		};
	}

	FinishLoadFile(f) {
		this.FileData = f;
		this.ParsePreviewData();
	}

	ParsePreviewData() {
		// console.log("Parse Data");

		this.LoadingFile = true;
		this.ReadyToImport = false;

		this.lstTable = [];
		this.lstCols = [];

		if (this.FormatOptionID == 1) {
			this.ParsePreviewTabData();
		} else if (this.FormatOptionID == 2) {
			this.ParsePreviewCsvData();
		}
	}

	ParsePreviewTabData() {
		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			for (var z = 0; z < lines.length; z++) {
				var next = lines[z];

				var tabs = next.split("\t");

				if (this.SkipFirstLineID == 0 || z > 0) {
					this.lstTable = [...this.lstTable, tabs];
				}

				if (z >= this.PreviewLines - 1 + this.SkipFirstLineID) {
					break;
				}
			}

			for (var z = 0; z < this.lstTable[0].length; z++) {
				this.lstCols = [...this.lstCols, 0];
				this.OptArray.push(0);
			}

			this.LoadingFile = false;
			this.ReadyToImport = true;
		} catch (e) {
			console.log(e);
			this.LoadingFile = false;
			this.ReadyToImport = false;
		}
	}

	ParsePreviewCsvData() {
		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			var nextLine = [];
			var nextCol = "";
			var inQuotes = false;

			for (var z = 0; z < lines.length; z++) {
				var line = lines[z];

				for (var i = 0; i < line.length; i++) {
					var next = line[i];

					if (next == '"') {
						inQuotes = !inQuotes;
					} else if (next == ",") {
						if (inQuotes == false) {
							nextLine.push(String(nextCol));
							nextCol = "";
						} else {
							nextCol += next;
						}
					} else {
						nextCol += next;
					}
				}

				if (nextCol != null && nextCol != "") {
					nextLine.push(String(nextCol));
					nextCol = "";
				}

				if (this.SkipFirstLineID == 0 || z > 0) {
					this.lstTable = [...this.lstTable, nextLine];
				}
				nextLine = [];

				if (z >= this.PreviewLines - 1 + this.SkipFirstLineID) {
					break;
				}
			}

			for (var z = 0; z < this.lstTable[0].length; z++) {
				this.lstCols = [...this.lstCols, 0];
				this.OptArray.push(0);
			}

			this.LoadingFile = false;
			this.ReadyToImport = true;
		} catch (e) {
			console.log(e);
			this.LoadingFile = false;
			this.ReadyToImport = false;
		}
	}

	onImport() {
		this.ErrorMessage = "";

		//
		// Validate Cols
		//

		var IDCount = 0;
		var EmailCount = 0;
		var IDCol = -1;
		var EmailCol = -1;

		for (var z = 0; z < this.OptArray.length; z++) {
			var next = this.OptArray[z];

			if (next == 1) {
				IDCol = z;
				IDCount++;
			} else if (next == 2) {
				EmailCol = z;
				EmailCount++;
			}
		}

		if (IDCount == 0) {
			this.ErrorMessage = "Select which column represents " + (this.AppTypeID == 3 ? "Staff" : "Student") + " ID";
			return;
		}
		if (EmailCount == 0) {
			this.ErrorMessage = "Select which column represents ";

			if (this.AppTypeID == 1) {
				this.ErrorMessage += "Guardian's";
			} else if (this.AppTypeID == 2) {
				this.ErrorMessage += "Student's";
			} else if (this.AppTypeID == 3) {
				this.ErrorMessage += "Staff's";
			}

			this.ErrorMessage += " Email";
			return;
		}
		if (IDCount > 1) {
			this.ErrorMessage = "Only 1 Column can represent " + (this.AppTypeID == 3 ? "Staff" : "Student") + " ID";
			return;
		}
		if (EmailCount > 1) {
			this.ErrorMessage = "Only 1 Column can represent ";

			if (this.AppTypeID == 1) {
				this.ErrorMessage += "Guardian's";
			} else if (this.AppTypeID == 2) {
				this.ErrorMessage += "Student's";
			} else if (this.AppTypeID == 3) {
				this.ErrorMessage += "Staff's";
			}

			this.ErrorMessage += " Email";

			return;
		}

		//
		// Parse All Data
		//

		var ParseResult = this.ParseAllData(IDCol, EmailCol);

		var parms: PortalAppImportDataRequest = {
			AppTypeID: this.AppTypeID,
			lstID: ParseResult[0],
			lstEmail: ParseResult[1],
		};

		this.ref.close(parms);
	}

	ParseAllData(IDCol: number, EmailCol: number): [string[], string[]] {
		if (this.FormatOptionID == 1) {
			return this.ParseAllTabData(IDCol, EmailCol);
		} else if (this.FormatOptionID == 2) {
			return this.ParseAllCsvData(IDCol, EmailCol);
		}
	}

	ParseAllTabData(IDCol: number, EmailCol: number): [string[], string[]] {
		var lstID: string[] = [];
		var lstEmail: string[] = [];

		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			for (var z = 0; z < lines.length; z++) {
				var next = lines[z];
				var tabs = next.split("\t");

				if (this.SkipFirstLineID == 0 || z > 0) {
					lstID.push(tabs[IDCol]);
					lstEmail.push(tabs[EmailCol]);
				}
			}
		} catch (e) {
			console.log(e);
		}

		return [lstID, lstEmail];
	}

	ParseAllCsvData(IDCol: number, EmailCol: number): [string[], string[]] {
		var lstID: string[] = [];
		var lstEmail: string[] = [];

		try {
			var lines: string[] = [];

			if (this.FileData.indexOf("\r\n") >= 0) {
				lines = this.FileData.split("\r\n");
			} else if (this.FileData.indexOf("\n") >= 0) {
				lines = this.FileData.split("\n");
			}

			var nextLine = [];
			var nextCol = "";
			var inQuotes = false;

			for (var z = 0; z < lines.length; z++) {
				var line = lines[z];

				for (var i = 0; i < line.length; i++) {
					var next = line[i];

					if (next == '"') {
						inQuotes = !inQuotes;
					} else if (next == ",") {
						if (inQuotes == false) {
							nextLine.push(String(nextCol));
							nextCol = "";
						} else {
							nextCol += next;
						}
					} else {
						nextCol += next;
					}
				}

				if (nextCol != null && nextCol != "") {
					nextLine.push(String(nextCol));
					nextCol = "";
				}

				// console.log("Next Line");
				// console.log(nextLine);

				if (this.SkipFirstLineID == 0 || z > 0) {
					if (nextLine.length > 0) {
						lstID.push(nextLine[IDCol]);
						lstEmail.push(nextLine[EmailCol]);
					}
				}

				nextLine = [];
			}
		} catch (e) {
			console.log(e);
		}

		return [lstID, lstEmail];
	}

	onCancel() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////

	onFormatOptionIDChange(val) {
		this.FormatOptionID = val;

		if (this.ImportFile != null) {
			this.ParsePreviewData();
		}
	}

	onSkipFirstLineIDChange(val) {
		this.SkipFirstLineID = val;

		if (this.ImportFile != null) {
			this.ParsePreviewData();
		}
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingFile == true || this.Processing == true;
	}

	///////////////////////////////////////////////////
}
